import { useMemo, useState } from 'react';
import ConfigDashboardTab from './config/ConfigDashboardTab';

/**
 * Sección extensible de configuraciones del admin.
 * Para agregar un área nueva: sumar un ítem a CONFIG_TABS.
 */
const CONFIG_TABS = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    description: 'Criterios del semáforo (pocos umbrales claros).',
    Component: ConfigDashboardTab,
  },
  // { id: 'otra', label: 'Otra', description: '…', Component: ConfigOtraTab },
];

export default function AdminConfiguraciones() {
  const [tabId, setTabId] = useState(CONFIG_TABS[0].id);

  const active = useMemo(
    () => CONFIG_TABS.find((t) => t.id === tabId) ?? CONFIG_TABS[0],
    [tabId],
  );
  const ActiveComponent = active.Component;

  return (
    <div className="p-6 max-w-3xl">
      <div className="mb-5">
        <h1 className="text-xl font-bold text-slate-800">Configuraciones</h1>
        <p className="text-sm text-slate-500 mt-1">
          Ajustes del panel de administración. Elegí una sección para editar.
        </p>
      </div>

      <div className="border-b border-slate-200 mb-5">
        <nav className="flex flex-wrap gap-1 -mb-px" aria-label="Secciones de configuración">
          {CONFIG_TABS.map((tab) => {
            const isActive = tab.id === active.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setTabId(tab.id)}
                className={`px-4 py-2.5 text-sm font-medium border-b-2 cursor-pointer transition-colors ${
                  isActive
                    ? 'border-violet-600 text-violet-700'
                    : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {active.description && (
        <p className="text-xs text-slate-400 mb-4">{active.description}</p>
      )}

      <ActiveComponent />
    </div>
  );
}
